import { render, staticRenderFns } from "./addWorkType.vue?vue&type=template&id=6e8f44ed&scoped=true"
import script from "./addWorkType.vue?vue&type=script&lang=js"
export * from "./addWorkType.vue?vue&type=script&lang=js"
import style0 from "./addWorkType.vue?vue&type=style&index=0&id=6e8f44ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8f44ed",
  null
  
)

export default component.exports